import { useRef } from 'react';
import * as THREE from 'three';
import { useFrame } from '@react-three/fiber';

interface PressureFieldProps {
  pressure: number;
}

export function PressureField({ pressure }: PressureFieldProps) {
  const meshRef = useRef<THREE.Mesh>(null);
  const materialRef = useRef<THREE.MeshStandardMaterial>(null);

  // Normalize pressure to a 0-1 range (assuming typical pressure range of 900-1100 hPa)
  const normalizedPressure = Math.max(0, Math.min(1, (pressure - 900) / 200));

  useFrame((state) => {
    if (meshRef.current && materialRef.current) {
      // Pulsing effect based on pressure
      const scale = 1 + Math.sin(state.clock.elapsedTime * 2) * 0.1 * normalizedPressure;
      meshRef.current.scale.set(scale, scale, scale);

      // Update material properties
      materialRef.current.opacity = 0.3 + normalizedPressure * 0.2;
      materialRef.current.emissiveIntensity = normalizedPressure * 0.5;
    }
  });

  return (
    <mesh ref={meshRef} position={[0, 0, 0]}>
      <circleGeometry args={[2, 32]} />
      <meshStandardMaterial
        ref={materialRef}
        color="#69db7c"
        transparent
        opacity={0.3}
        emissive="#69db7c"
        emissiveIntensity={0.2}
        side={THREE.DoubleSide}
      />
    </mesh>
  );
} 